import { render, staticRenderFns } from "./modalTabs.vue?vue&type=template&id=964e0f0e&scoped=true&"
import script from "./modalTabs.vue?vue&type=script&lang=js&"
export * from "./modalTabs.vue?vue&type=script&lang=js&"
import style0 from "./modalTabs.vue?vue&type=style&index=0&id=964e0f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964e0f0e",
  null
  
)

export default component.exports